import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import Header from "../components/Header";
import { useTranslation } from "react-i18next";

const Intro = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Header nameClass={"transparent-header"} />
      <div className="intro-page-holder-main">
        <div className="intro-page-holder">
          <div className="intro-page-center">
            <h1>LG MASTER KLUB</h1>
            <h2>{t("intro_page.inspiration_text")}</h2>
          </div>
          <div className="intro-page-button-holder">
            <div className="intro-page-button-login">
              <Button
                component={Link}
                to="/login"
                className="intro-page-button"
              >
                {t("login.prijava")}
              </Button>
              <div className="registration-holder-intro d-flex justify-content-between align-items-center">
                <div className="intro-page-registration-holder-1">
                  {t("login.nemate_nalog")}
                </div>
                <div className="intro-page-registration-holder-2">
                  <Link to="/registration">{t("login.registruj_se")}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Intro;
